import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

function UserManagement({ currentUser }) {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetch('https://api.stitchtechsolutions.com/api/list_users.php')
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setUsers(data.users);
        } else {
          Swal.fire('Error', data.message, 'error');
        }
      })
      .catch(() => {
        Swal.fire('Error', 'Failed to load users', 'error');
      });
  }, []);

  const isAdmin = currentUser?.role === 'superadmin';

  const handleEdit = (user) => {
    Swal.fire({
      title: `Edit User: ${user.username}`,
      customClass: {
        popup: 'modal-edit-user'
      },
      html: `
        <div class="modal-form-group">
          <label for="first_name">First Name</label>
          <input id="first_name" class="swal2-input" value="${user.first_name || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="middle_name">Middle Name</label>
          <input id="middle_name" class="swal2-input" value="${user.middle_name || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="last_name">Last Name</label>
          <input id="last_name" class="swal2-input" value="${user.last_name || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="email">Email</label>
          <input id="email" class="swal2-input" value="${user.email || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="employee_id">Employee ID</label>
          <input id="employee_id" class="swal2-input" value="${user.employee_id || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="role">Role</label>
          <select id="role" class="swal2-input">
            <option value="standard" ${user.role === 'standard' ? 'selected' : ''}>Standard</option>
            <option value="admin" ${user.role === 'admin' ? 'selected' : ''}>Admin</option>
            <option value="superadmin" ${user.role === 'superadmin' ? 'selected' : ''}>Super Admin</option>
          </select>
        </div>
        <div class="modal-form-group">
          <label for="status">Status</label>
          <select id="status" class="swal2-input">
            <option value="active" ${user.status === 'active' ? 'selected' : ''}>Active</option>
            <option value="inactive" ${user.status === 'inactive' ? 'selected' : ''}>Inactive</option>
          </select>
        </div>
        ${isAdmin ? `
        <div class="modal-form-group">
          <label for="username">Username</label>
          <input id="username" class="swal2-input" value="${user.username || ''}" />
        </div>
        <div class="modal-form-group">
          <label for="password">New Password (leave blank to keep current)</label>
          <input id="password" type="password" class="swal2-input" placeholder="Enter new password" />
        </div>
        ` : ''}
      `,
      preConfirm: () => {
        const payload = {
          id: user.id,
          first_name: document.getElementById('first_name').value,
          middle_name: document.getElementById('middle_name').value,
          last_name: document.getElementById('last_name').value,
          email: document.getElementById('email').value,
          employee_id: document.getElementById('employee_id').value,
          role: document.getElementById('role').value,
          status: document.getElementById('status').value,
        };
        if (isAdmin) {
          payload.username = document.getElementById('username').value;
          payload.password = document.getElementById('password').value;
        }
        return payload;
      },
      showCancelButton: true,
      confirmButtonText: '💾 Save Changes',
      cancelButtonText: 'Cancel',
      width: '600px'
    }).then((result) => {
      if (result.isConfirmed) {
        fetch('https://api.stitchtechsolutions.com/api/update_user.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(result.value),
        })
          .then(res => res.json())
          .then(data => {
            if (data.status === 'success') {
              Swal.fire('Success', data.message, 'success');
              setUsers(prev =>
                prev.map(u =>
                  u.id === user.id ? { ...u, ...result.value } : u
                )
              );
            } else {
              Swal.fire('Error', data.message, 'error');
            }
          });
      }
    });
  };
  
  
  return (
    <div className="user-management">
      <h2>User Management</h2>
      <div className="user-table-container">
        <table className="user-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Employee ID</th>
              <th>Role</th>
              <th>Status</th>
              {isAdmin && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {users.map(user => {
              const fullName = [user.first_name, user.middle_name, user.last_name].filter(Boolean).join(' ');
              return (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.username}</td>
                  <td>{fullName}</td>
                  <td>{user.email}</td>
                  <td>{user.employee_id}</td>
                  <td>{user.role}</td>
                  <td>{user.status}</td>
                  {isAdmin && (
                    <td>
                      <button onClick={() => handleEdit(user)}>Edit</button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserManagement;
